import { IconButton } from '@mui/material';
import { ConfirmationDialog } from '../../../../dialogs';
import React, { Fragment, ReactElement, useState } from 'react';
import { Trash2 } from 'react-feather';

interface DeleteButtonProps {
  title: string;
  message?: string;
  id?: string;
  loading?: boolean;
  onDelete?: () => void;
}

export function DeleteButton({
  id,
  loading,
  title,
  message,
  onDelete,
}: DeleteButtonProps): ReactElement {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <IconButton
        color="secondary"
        data-test-id={`common-delete-button-${id}`}
        aria-label="Delete"
        onClick={() => setOpen(true)}
        size="large"
      >
        <Trash2 size={20} />
      </IconButton>
      <ConfirmationDialog
        loading={loading}
        title={title}
        message={message}
        confirmButtonText="Delete"
        isOpened={open}
        onConfirm={() => {
          onDelete();
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
      />
    </Fragment>
  );
}
